import { createIcon } from './IconFactory';

// Icônes existantes
export const AddIcon = createIcon('add');
export const CheckIcon = createIcon('check');
export const DeleteIcon = createIcon('delete');
export const SearchIcon = createIcon('search');
export const EditIcon = createIcon('edit');
export const PenIcon = createIcon('pen');
export const ArrowIcon = createIcon('arrow');
export const DownloadIcon = createIcon('download');
export const UploadIcon = createIcon('upload');
export const MenuIcon = createIcon('menu');
export const CloseIcon = createIcon('close');
export const XMarkIcon = createIcon('xmark');
export const ListIcon = createIcon('list');
export const MoreVerticalIcon = createIcon('moreVertical');
export const MoreHorizontalIcon = createIcon('moreHorizontal');
export const MandateIcon = createIcon('mandate');
export const EyeIcon = createIcon('eye');
export const DocumentsIcon = createIcon('documents');
export const DocumentIcon = createIcon('document');
export const ContractIcon = createIcon('contract');
export const HandshakeIcon = createIcon('handshake');
export const PdfIcon = createIcon('pdf');


// Nouvelles icônes ajoutées
export const HomeIcon = createIcon('home');
export const SettingsIcon = createIcon('settings');
export const UserIcon = createIcon('user');
export const NotificationIcon = createIcon('notification');
export const CalendarIcon = createIcon('calendar');
export const HeartIcon = createIcon('heart');
export const StarIcon = createIcon('star');
export const ChevronDownIcon = createIcon('chevronDown');
export const ChevronUpIcon = createIcon('chevronUp');
export const ChevronLeftIcon = createIcon('chevronLeft');
export const ChevronRightIcon = createIcon('chevronRight');
export const InfoIcon = createIcon('info');
export const WarningIcon = createIcon('warning');
export const ErrorIcon = createIcon('error');
export const QuestionIcon = createIcon('question');
export const GlobeIcon = createIcon('globe');
export const MailIcon = createIcon('mail');
export const PhoneIcon = createIcon('phone');
export const LocationIcon = createIcon('location');
export const LockIcon = createIcon('lock');
export const UnlockIcon = createIcon('unlock');
export const CameraIcon = createIcon('camera');
export const ImageIcon = createIcon('image');
export const ShareIcon = createIcon('share');
export const BookmarkIcon = createIcon('bookmark');
export const TagIcon = createIcon('tag');
export const LightningIcon = createIcon('lightning');
export const ChatIcon = createIcon('chat');
export const RefreshIcon = createIcon('refresh');
export const ShieldIcon = createIcon('shield');
export const TrashIcon = createIcon('trash');
export const CartIcon = createIcon('cart');
export const MusicIcon = createIcon('music');
export const LinkIcon = createIcon('link');
export const FilterIcon = createIcon('filter');
export const AdjustmentsIcon = createIcon('adjustments');
export const MoonIcon = createIcon('moon');
export const SunIcon = createIcon('sun');
export const LaptopIcon = createIcon('laptop');
export const DesktopIcon = createIcon('desktop');
export const MobileIcon = createIcon('mobile');
export const LogoutIcon = createIcon('logout');
export const LoginIcon = createIcon('login');
export const TemplateIcon = createIcon('template');
export const CubeIcon = createIcon('cube');
export const SaveIcon = createIcon('save');
export const PrintIcon = createIcon('print');
export const ClipboardIcon = createIcon('clipboard');
export const PlayIcon = createIcon('play');
export const PauseIcon = createIcon('pause');
export const StopIcon = createIcon('stop');
export const MicrophoneIcon = createIcon('microphone');
export const VideoIcon = createIcon('video');
export const ChartIcon = createIcon('chart');
export const GridIcon = createIcon('grid');

// Icônes avec cercle (pour GenericBox, etc.)
export const UmbrellaCircleIcon = createIcon('umbrellaCircle');
export const BienCircleIcon = createIcon('houseBlue');
export const CoprorieteCircleIcon = createIcon('coprorieteCircle');
export const UserCircleIcon = createIcon('userCircle');
